var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.87,88.395L74.507,66.029c11.678-15.836,10.307-38.56-3.913-52.779C62.933,5.592,52.75,1.374,41.92,1.374  c-10.831,0-21.013,4.218-28.669,11.876C5.592,20.91,1.374,31.091,1.374,41.92c0,10.83,4.218,21.012,11.877,28.673  c7.657,7.659,17.839,11.877,28.671,11.877c8.766,0,17.167-2.797,24.115-7.956l22.358,22.354c1.132,1.133,2.637,1.756,4.237,1.756  c1.605,0,3.113-0.627,4.232-1.751c1.134-1.131,1.759-2.636,1.76-4.238S98.002,89.527,96.87,88.395z M41.92,13.359  c7.628,0,14.8,2.971,20.196,8.367c5.385,5.384,8.351,12.556,8.351,20.194s-2.966,14.811-8.352,20.196  c-5.394,5.395-12.566,8.366-20.195,8.366c-7.628,0-14.8-2.971-20.196-8.366c-5.395-5.393-8.366-12.565-8.366-20.196  c0-7.628,2.971-14.8,8.366-20.194C27.121,16.331,34.293,13.359,41.92,13.359z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.be0e3ad1f5ab4a407bad2eeaff1118d1.svg";
export { ForwardRef as ReactComponent };